import React, {useCallback, useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import uuid from "uuid";

import PricingContext, {usePricingContext} from "../PricingContext";
import AddButton from "../PricingComponents/AddButton";
import {setPricingCatalogs, showPricingPopup} from "../pricingActions";
import {deleteCatalog, getPricingCatalogs} from "./pricingCatalogAsyncActions";
import ROUTES from "../../../routes";
import useOutsideClick from "../../../utilities/helperHooks";
import PRICING_POPUP_TYPES from "../PricingPopups/pricingPopupTypes";


const PricingCatalogs = (props) => {

  const {getPricingCatalogs, setPricingCatalogs, pricingCatalogsLoading, pricingCatalogs, deleteCatalog,
    showPricingPopup} = props;

  const {routeParams} = usePricingContext(PricingContext);
  const {paramsGroupName, paramsCatalogName} = routeParams;

  const [addOpened, setAddOpened] = useState(false);
  const selectElement = useRef(null);

  useOutsideClick(selectElement, () => {
    if (addOpened) {
      setAddOpened(false);
    }
  }, []);

  useEffect(() => {
    if (!paramsGroupName) {
      return
    }
    getPricingCatalogs(paramsGroupName, paramsCatalogName);
    return () => {
      setPricingCatalogs([]);
    }
  }, [paramsGroupName]);

  const sidebarCatalogClick = useCallback((clickedCatalog) => {
    if (clickedCatalog.isActive) {
      return
    }
    hashHistory.push(ROUTES.pricing + "/" + paramsGroupName + "/" + clickedCatalog.newCustomName);
    setPricingCatalogs([...pricingCatalogs.map(catalog => {
      catalog.isActive = catalog.id === clickedCatalog.id;
      return catalog
    })])
  }, [hashHistory, pricingCatalogs, setPricingCatalogs]);

  const removeCatalogClick = useCallback((clickedCatalog) => {
    hashHistory.push(ROUTES.pricing + "/" + paramsGroupName + "/");
    setPricingCatalogs([...pricingCatalogs.filter(catalog => catalog.id !== clickedCatalog.id)]);
    if (typeof clickedCatalog.id !== "string") { // we didn't save it yet, it has temp uuid id
      deleteCatalog(clickedCatalog);
    }
  }, [hashHistory, pricingCatalogs, setPricingCatalogs, deleteCatalog]);

  const addExistingCatalogClick = useCallback(() => {
    showPricingPopup(true, PRICING_POPUP_TYPES.allCatalogs)
    setAddOpened(false);
  }, [])

  const addNewCatalogClick = useCallback(() => {
    const catalogInput = document.getElementById("catalogNameInput");
    if (catalogInput) {
      catalogInput.focus();
      catalogInput.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      hashHistory.push(ROUTES.pricing + "/" + paramsGroupName);
      setPricingCatalogs([...pricingCatalogs.map(catalog => {
        catalog.isActive = false;
        return catalog
      }), {
        needToSaveCatalog: true,
        id: uuid.v4(),
        groupName: paramsGroupName,
        name: "New",
        newCustomName: "",
        isActive: true
      }]);
    }
    setAddOpened(false);
  }, [paramsGroupName, setPricingCatalogs, pricingCatalogs])

  const styles = {
    height: addOpened ? "67px" : 0,
    width: "120px",
  }

  return (
    <div className="flex-1 pr-aside__cell flex flex--column height-100 border-box">
      <div className={"flex flex--center pb-0-25 relative" + (addOpened ? " select3--active" : "")}
           ref={selectElement}>
        <AddButton text="Add Catalog" onClick={() => setAddOpened(!addOpened)}/>
        <div className="select3-dropdown" style={styles}>
          <ul className="select3-dropdown__list">
            <li className="select3-dropdown__list-item"
                onClick={addExistingCatalogClick}>
              <span className="select3-dropdown__list-item-text">Add Existing</span>
            </li>
            <li className="select3-dropdown__list-item"
                onClick={addNewCatalogClick}>
              <span className="select3-dropdown__list-item-text">Create New</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex-item">
        {pricingCatalogsLoading
          ? <div className="ui-loader ui-loader--medium" style={{height: "98px"}}/>
          : pricingCatalogs.map(pricingCatalog => {
            return (
              <div className={"pt-1 pb-1 pl-05 pr-05 flex flex--center nowrap link pr-aside__cell-item text-center"
                + (pricingCatalog.isActive ? " bg-darkgreen2 color-light" : " bg-mochagrunge")}
                   onClick={() => sidebarCatalogClick(pricingCatalog)}
                   key={pricingCatalog.id || pricingCatalog.name}>
                  <span className="font--14 bold width-100">
                    {pricingCatalog.newCustomName || pricingCatalog.name}
                  </span>
                {pricingCatalog.isActive ? (
                  <button className="ui-icon-remove2 ui-icon-remove2--small h-1 ui-icon-remove2--hover-white"
                          onClick={() => removeCatalogClick(pricingCatalog)}/>
                ) : null}
              </div>
            )
          })}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingCatalogs, pricingCatalogsLoading} = store.pricingState;

  return {
    pricingCatalogs,
    pricingCatalogsLoading,
  };
};

const mapDispatchToProps = {
  setPricingCatalogs,
  getPricingCatalogs,
  deleteCatalog,
  showPricingPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingCatalogs);
